<template>
    <div class="TopicsTopEntrance" v-loading="loading">
        <div class="TopicsTopEntrance-header">
            <div>类目管理</div>
            <div>
                <el-button type="primary" @click="handleAdd">新增</el-button>
            </div>
        </div>
        <el-table :data="tableData" border>
            <el-table-column type="index" label="序号" align="center" width="120" />
            <el-table-column prop="name" label="类目" align="center" />
            <el-table-column prop="contentCount" label="弹幕内容数量" align="center" />
            <el-table-column prop="sendCount" label="发送数量" align="center" />
            <el-table-column label="更新时间" align="center" inline-template>
                <div>{{ new Date(row.updateTime).format('yyyy-MM-dd hh:mm:ss') }}</div>
            </el-table-column>
            <el-table-column inline-template label="操作" width="200px" align="center">
                <template>
                    <el-button type="primary" size="small" @click="handleEdit(row)">
                        编辑
                    </el-button>
                    <el-button type="primary" size="small" @click="handleDelete(row)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination layout="prev, pager, next, jumper" :page-size="queryForm.pageSize"
                :current-page="queryForm.pageNum" :total="tableTotal" @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            queryForm: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            tableTotal: 0,
            loading: false
        }
    },
    mounted() {
        this.getTableData()
    },
    methods: {
        // 请求分页数据分页
        handleCurrentChange(val) {
            this.queryForm.pageNum = val;
            this.getTableData()
        },
        handleAdd() {
            this.$prompt('类目名称', '新增', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                if (!value) {
                    return
                }
                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/barrage/category/add',
                    body: JSON.stringify({
                        name: value
                    })
                }).then(res => {
                    if (res.body.error === 10000) {
                        this.$util.successMsg('操作成功');
                        this.getTableData()
                    } else {
                        this.$util.errorMsg(res.body.message);
                    }
                }).catch(() => {
                    this.$util.errorMsg('服务器内部错误');
                })
            })
        },
        handleDelete(row) {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    method: 'GET',
                    url: this.$util.domain + '/adminapi/barrage/category/delete',
                    params: {
                        categoryId: row.id
                    }
                }).then(res => {
                    if (res.body.error === 10000) {
                        this.getTableData()
                    } else {
                        this.$util.errorMsg(res.body.message);
                    }
                })
            })
        },
        handleEdit(row) {
            this.$prompt('类目名称', '编辑', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                if (!value) {
                    return
                }
                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/barrage/category/add',
                    body: JSON.stringify({
                        id: row.id,
                        name: value
                    })
                }).then(res => {
                    if (res.body.error === 10000) {
                        this.$util.successMsg('操作成功');
                        this.getTableData()
                    } else {
                        this.$util.errorMsg(res.body.message);
                    }
                }).catch(() => {
                    this.$util.errorMsg('服务器内部错误');
                })
            })
        },
        getTableData() {
            this.loading = true
            this.$http({
                method: 'GET',
                url: this.$util.domain + '/adminapi/barrage/category/list',
                params: {
                    ...this.queryForm
                }
            }).then(res => {
                if (res.body.error === 10000) {
                    const { list, totalCount } = res.body.data
                    this.tableTotal = totalCount
                    if (list && list.length) {
                        this.tableData = list
                    } else {
                        this.tableData = []
                    }
                } else {
                    this.tableData = []
                    this.tableTotal = 0
                    this.$util.errorMsg(res.body.message);
                }
                this.loading = false
            }).catch(() => {
                this.tableData = []
                this.tableTotal = 0
                this.loading = false
            })
        }
    }
}
</script>


<style scoped>
.TopicsTopEntrance-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #eee;
    font-size: 16px;
    padding: 0 10px 0 30px;
    margin: 20px 0;
}

.TopicsTopEntrance-main {
    padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// index.vue?3b0a3532